import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';
import { formatNZD } from '@sparknz/journeys-common';

import { Phone } from '../../../typings';

export function getMakes(deviceData?: Phone[]) {
  const makes = deviceData?.map(({ Make }) => ({ label: Make, value: Make }));

  return sortBy(uniqBy(makes, 'label'), 'label');
}

export function getDevicesByMake(brand: string, deviceData?: Phone[]) {
  const devices = deviceData?.filter((item) => item.Make === brand) || [];

  return sortBy(
    devices.map(({ Model, Memory, DeviceID }) => ({
      label: `${Model} ${Memory || ''}`.trim(),
      value: DeviceID,
    })),
    'label',
  );
}

export function getDeviceById(
  deviceId: string,
  deviceData?: Phone[],
): Phone | null {
  return deviceData?.find((item) => item.DeviceID === deviceId) || null;
}

export function getDiscountMessage(selectedDeviceData: Phone) {
  const maxTradeInValue = Number(selectedDeviceData.maxTradeInValue);
  const memoryText = selectedDeviceData.Memory
    ? ` ${selectedDeviceData.Memory}`
    : '';

  return `You could get up to ${formatNZD(maxTradeInValue)} for your old ${
    selectedDeviceData.Make
  } ${selectedDeviceData.Model}${memoryText}.`;
}
